<template>
<div>
    <v-layout>
        <v-text-field append-icon="search" :label="etiket" @click:append="dialogac()" :tabindex="tabdeger" v-model="val" hide-details=""></v-text-field>
    </v-layout>
    <v-dialog scrollable="" v-model="dialog" max-width="550px">
        <v-card color="grey lighten-5">
            <v-toolbar size="120px" color="info">
                <v-toolbar-title class="white--text"> {{  $t("Bank-Code-List") }}</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-text-field solo hide-details ref="ara" autofocus="" v-model="secilendeger" :label="this.$t('Search')" append-icon="search"></v-text-field>
            </v-toolbar>
            <v-card-text>
                <v-layout row="" wrap="">
                    <div class="flex md12">
                        <v-data-table :headers="headersservis" :loading="progress" :items="items" :search="secilendeger" hide-actions class="elevation-1">
                            <v-progress-linear slot="progress" indeterminate></v-progress-linear>
                            <template slot="items" slot-scope="props">
                                <tr @click="kabul(props.item.BankaKod)" item>
                                    <td class="text-xs-left">{{ props.item.BankaKod }}</td>
                                    <td class="text-xs-left">{{ props.item.BankaKisaKod }}</td>
                                    <td class="text-xs-left">{{props.item.BankaAdi}}</td>
                                </tr>
                            </template>
                        </v-data-table>
                    </div>
                </v-layout>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary" flat @click="dialog = false">
                    {{$t("cancel_button")}}
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
    <v-card>
        <v-snackbar :timeout="timeout" :top="y === 'top'" :bottom="y === 'bottom'" :right="x === 'right'" :left="x === 'left'" :multi-line="mode === 'multi-line'" :vertical="mode === 'vertical'" v-model="snackbar">
            {{ text1 }}
            <v-btn flat color="pink" @click.native="snackbar = false">{{$t("Close")}}</v-btn>
        </v-snackbar>
    </v-card>
</div>
</template>

<script>
import auth from '../../../api/auth'

export default {
    //props: ["value", "tabdeger","etiket"],
    props: {
        value: {
            type: String
        },
        tabdeger: {
            type: Number
        },
        etiket: {
            type: String,
            default: "Bank Code"
        }
    },
    computed: {
        val: {
            get: function () {
                return this.value;
            },
            set: function (newValue) {
                this.$emit('input', newValue)
            },
        },
    },

    beforeMount: beforeMount,
    methods: {
        dialogac: dialogac,
        kabul: kabul,
        getList:getList,
    },
    data() {
        return {
            headersservis: [{
                    text: this.$t('Bank-Code'),
                    value: 'BankaKod'
                },
                {
                    text: this.$t('Short-Code'),
                    value: 'BankaKisaKod'
                },
                {
                    text: this.$t('Bank-Name'),
                    value: 'BankaAdi'
                }
            ],
            progress: false,
            items: [],
            secilendeger: null,
            dialog: false,
            text1: null,
            loading: false,
            snackbar: false,
            y: 'top',
            x: 'right',
            mode: '',
            timeout: 6000,
        }
    },
    watch: {

        dialog(val2) {
            if (!val2) return
            requestAnimationFrame(() => {
                this.$refs.ara.focus()
            })
        }

    },
}

function kabul(m) {
    this.val = m
    this.dialog = false
}

function dialogac() {
    this.getList()
    this.dialog = true
}

function getList(){
    var credentials = JSON.parse(window.localStorage.getItem('credentials'));

    var params1 = {
        CompanyCode: credentials.SirketKodu,
    }

    this.$http.post(auth.API_URL + 'api/Bank/List', params1, {
        headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
        }
    }).then((response) => {
        this.items = response.body

        this.progress = false
    }, (response) => {
        if (response.status === 0) {
            this.text1 = 'Service Unavailable-BankList'
            this.snackbar = true
            this.progress = false

        } else {
            this.text1 = 'Service Unavailable-BankList'
            this.snackbar = true
            this.progress = false
        }
    })
}
function beforeMount() {

}
</script>
